import { Button, Form, Input, InputNumber, Modal, Radio, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { SignalContext } from "context/SignalContext";
import { safeParseJSON } from "lib/utils";
export default function ({ deviceId, orgId }) {
  const [isAsync, setIsAsync] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [waitingId, setWaitingId] = useState("");
  const [result, setResult] = useState("");
  const { sendWsRequest } = useWsSender();
  const [form] = useForm();
  const { wsMsgData } = useContext(SignalContext);
  const deviceForward = async () => {
    try {
      const values = form.getFieldsValue();
      const res: any = await sendWsRequest(
        "device.exec_cmd",
        {
          execCmd: {
            async: isAsync,
            deviceId,
            cmd: values.cmd,
            params: values.params,
          },
        },
        { orgId },
      );
      if (!isAsync) {
        setResult(res.execCmdReply?.output || "-");
      } else {
        setWaitingId(res.__wsRequestId);
        showToast(0, "Forward success");
        setResult("waiting for result...");
      }
    } catch (e) {
      console.error(e);
      const error = safeParseJSON(e.message);
      if (error?.message) {
        showToast(1, error?.message);
      } else {
        showToast(1, "Forward failed");
      }
    }
  };
  useEffect(() => {
    if (waitingId && wsMsgData && wsMsgData.result?.id === waitingId) {
      setResult(wsMsgData.result?.data?.execCmdReply?.output || "-");
      if (wsMsgData.result?.data?.execCmdReply?.done) {
        setWaitingId("");
        showToast(0, "Task done");
      }
    }
  }, [wsMsgData, waitingId]);
  return (
    <>
      <Button onClick={() => setModalShow(true)} type="link">
        Exec Cmd
      </Button>
      <Modal
        title={"Forward to device"}
        open={modalShow}
        okButtonProps={{ className: "primaryButton" }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
        onOk={deviceForward}
      >
        <Radio.Group
          value={isAsync}
          onChange={(e) => setIsAsync(e.target.value)}
          options={[
            { label: "Async", value: true },
            { label: "Sync", value: false },
          ]}
        />

        <Form
          name="dynamic_form_item"
          style={{ maxWidth: 600, marginTop: "12px" }}
          form={form}
        >
          <Form.Item name="cmd" label="Cmd">
            <Select
              style={{ width: "60%" }}
              options={[
                // { label: "upgrade_camera", value: "upgrade_camera" },
                { label: "custom", value: "custom" },
              ]}
            />
          </Form.Item>
          <Form.List name="params">
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item label={"param"} required={false} key={field.key}>
                    <Form.Item noStyle {...field}>
                      <Input placeholder="param" style={{ width: "60%" }} />
                    </Form.Item>
                    {fields.length > 1 ? (
                      <MinusCircleOutlined
                        className="dynamic-delete-button"
                        onClick={() => remove(field.name)}
                      />
                    ) : null}
                  </Form.Item>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    style={{ width: "60%" }}
                    icon={<PlusOutlined />}
                  >
                    Add field
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
        <Input.TextArea value={result} disabled={true} rows={5} />
      </Modal>
    </>
  );
}
